import type { AnimationDefinition, AnnotationScene, EditCommand } from "@linempo/project-domain";

/** Author in the saved picture's time basis, independent of clip position or playback speed. */
export function annotationAuthoringView(scene: AnnotationScene, animation: AnimationDefinition): AnnotationScene {
  return {
    ...scene, startMs: 0, endMs: animation.localDurationMs, drawMode: animation.drawMode,
    manualStrokes: animation.manualStrokes, fillRegions: animation.fillRegions,
    protectionRegions: animation.protectionRegions,
  };
}

export function annotationAuthoringEdit(animationId: string, view: AnnotationScene): EditCommand {
  return {
    _tag: "UpdateAnimationAnnotations", animationId, drawMode: view.drawMode,
    manualStrokes: view.manualStrokes, fillRegions: view.fillRegions, protectionRegions: view.protectionRegions,
  };
}
